import { Link } from "react-router-dom";

import { APP_NAME } from "../constants/brand";

export function PrivacyPage() {
  return (
    <section className="legal-page">
      <header className="legal-header">
        <Link to="/auth" className="legal-back-link">&larr; Torna al login</Link>
        <h1>Informativa Privacy</h1>
        <p className="legal-meta">Ultimo aggiornamento: 23 maggio 2026</p>
      </header>

      <article className="legal-content">
        <p>
          La presente informativa descrive il trattamento dei dati personali effettuato da{" "}
          <strong>{APP_NAME}</strong> ai sensi degli articoli 13 e 14 del Regolamento (UE) 2016/679
          (&laquo;GDPR&raquo;) e del D.Lgs. 196/2003 (Codice Privacy italiano, come modificato dal
          D.Lgs. 101/2018).
        </p>

        <h2>1. Titolare e responsabile del trattamento</h2>
        <p>
          {APP_NAME} è una piattaforma SaaS multi-tenant per la gestione dei solleciti di pagamento.
          Rispetto ai dati dei <strong>debitori</strong> caricati dai clienti (studi professionali e
          aziende), {APP_NAME} opera come <strong>responsabile del trattamento</strong> ex art. 28 GDPR.
          Rispetto ai dati degli <strong>utenti</strong> che si registrano alla piattaforma (titolari
          dei workspace), {APP_NAME} opera come <strong>titolare del trattamento</strong>.
        </p>
        <p>
          Per esercitare i tuoi diritti o richiedere informazioni puoi scrivere a{" "}
          <a href="mailto:privacy@incassaflow.it">privacy@incassaflow.it</a>.
        </p>

        <h2>2. Categorie di dati trattati</h2>
        <ul>
          <li>
            <strong>Dati utente piattaforma</strong>: nome, indirizzo email, password (cifrata),
            dati di fatturazione, log di accesso e attività.
          </li>
          <li>
            <strong>Dati workspace</strong>: ragione sociale, P.IVA, IBAN, firma email, configurazioni
            di canali email/WhatsApp, template di comunicazione.
          </li>
          <li>
            <strong>Dati debitori (caricati dall&apos;utente)</strong>: anagrafica cliente (nome,
            email, telefono, codice fiscale, partita IVA, indirizzo), dati fattura (riferimento,
            importo, scadenza), contenuto delle comunicazioni email/WhatsApp scambiate.
          </li>
        </ul>

        <h2>3. Finalità e basi giuridiche</h2>
        <ul>
          <li>
            <strong>Erogazione del servizio</strong> (art. 6(1)(b) GDPR — esecuzione del contratto).
          </li>
          <li>
            <strong>Gestione amministrativa e fatturazione</strong> (art. 6(1)(c) GDPR — obblighi
            legali).
          </li>
          <li>
            <strong>Analisi AI delle risposte dei debitori</strong> (art. 6(1)(f) GDPR — legittimo
            interesse del titolare del workspace al recupero del credito, bilanciato con i diritti
            del debitore). Vedi sezione 5.
          </li>
          <li>
            <strong>Sicurezza, prevenzione frodi, log di accesso</strong> (art. 6(1)(f) GDPR —
            legittimo interesse).
          </li>
        </ul>

        <h2>4. Modalità del trattamento e conservazione</h2>
        <p>
          I dati sono trattati con strumenti elettronici, con misure di sicurezza adeguate
          (cifratura in transito TLS 1.2+, controllo accessi multi-tenant, audit log per ogni
          operazione critica). I dati sono conservati per la durata del rapporto contrattuale e
          successivamente per il tempo necessario ad adempiere agli obblighi di legge (es. tributari
          e contabili: 10 anni ex art. 2220 c.c.).
        </p>

        <h2>5. Trattamento tramite intelligenza artificiale</h2>
        <p>
          {APP_NAME} integra funzionalità di intelligenza artificiale per supportare l&apos;operatore
          nelle attività di recupero credito. Sono adottate misure specifiche:
        </p>
        <ul>
          <li>
            <strong>Pseudonimizzazione automatica</strong> (art. 4(5) GDPR) dei contenuti email/WhatsApp
            dei debitori prima della trasmissione al provider AI di analisi (Mistral AI SAS, Francia —
            infrastruttura UE). Nome, email, telefono, codice fiscale, P.IVA, IBAN sono sostituiti
            con placeholder.
          </li>
          <li>
            <strong>Nessuna decisione esclusivamente automatizzata</strong> (art. 22 GDPR): l&apos;AI
            produce solo suggerimenti; ogni azione operativa resta in capo a un operatore umano.
          </li>
          <li>
            <strong>Nessun addestramento</strong>: i provider AI utilizzati garantiscono
            contrattualmente che i dati trasmessi via API non vengono usati per addestrare i modelli.
          </li>
          <li>
            <strong>Architettura 3-tier</strong>: la generazione di contenuti generici e gli
            insight aggregati usano Google Gemini (USA, dati non personali); l&apos;analisi di
            messaggi inbound con PII usa Mistral AI (UE).
          </li>
        </ul>

        <h2>6. Destinatari e trasferimenti extra-UE</h2>
        <p>
          I dati possono essere comunicati a:
        </p>
        <ul>
          <li>
            <strong>Mistral AI SAS</strong> (Francia, UE) — analisi messaggi inbound previa
            pseudonimizzazione. Nessun trasferimento extra-UE.
          </li>
          <li>
            <strong>Google LLC</strong> (USA) — generazione contenuti e statistiche aggregate (dati
            non personali). Trasferimento basato su Clausole Contrattuali Standard.
          </li>
          <li>
            <strong>Meta Platforms Ireland Ltd.</strong> (Irlanda) — invio messaggi WhatsApp tramite
            Cloud API (solo quando l&apos;utente configura il canale WhatsApp).
          </li>
          <li>
            <strong>Stripe Payments Europe Ltd.</strong> (Irlanda) — gestione pagamenti
            dell&apos;abbonamento alla piattaforma.
          </li>
          <li>
            <strong>Provider SMTP</strong> configurato dall&apos;utente per l&apos;invio email.
          </li>
        </ul>

        <h2>7. Diritti dell&apos;interessato</h2>
        <p>Hai diritto in qualsiasi momento di esercitare i diritti previsti dagli articoli 15-22 GDPR:</p>
        <ul>
          <li>Accesso ai dati (art. 15)</li>
          <li>Rettifica (art. 16)</li>
          <li>Cancellazione &laquo;diritto all&apos;oblio&raquo; (art. 17)</li>
          <li>Limitazione del trattamento (art. 18)</li>
          <li>Portabilità (art. 20)</li>
          <li>Opposizione (art. 21)</li>
          <li>Non essere sottoposto a decisione esclusivamente automatizzata (art. 22)</li>
        </ul>
        <p>
          Per esercitarli scrivi a <a href="mailto:privacy@incassaflow.it">privacy@incassaflow.it</a>.
          Hai inoltre diritto di proporre reclamo al Garante per la protezione dei dati personali
          (<a href="https://www.garanteprivacy.it" target="_blank" rel="noopener">www.garanteprivacy.it</a>).
        </p>

        <h2>8. Trattamento dati dei debitori</h2>
        <p>
          Se i tuoi dati sono stati caricati su {APP_NAME} da un creditore (es. studio professionale,
          azienda) in qualità di debitore, il titolare del trattamento è il creditore stesso.
          {APP_NAME} agisce come responsabile del trattamento (art. 28 GDPR). Per esercitare i tuoi
          diritti contatta il creditore titolare; in subordine, puoi scriverci a{" "}
          <a href="mailto:privacy@incassaflow.it">privacy@incassaflow.it</a>.
        </p>

        <h2>9. Cookie e tecnologie di tracciamento</h2>
        <p>
          {APP_NAME} utilizza esclusivamente cookie tecnici necessari al funzionamento della
          piattaforma (autenticazione, persistenza della sessione). Non utilizziamo cookie di
          profilazione di terze parti.
        </p>

        <h2>10. Modifiche all&apos;informativa</h2>
        <p>
          Eventuali aggiornamenti saranno pubblicati su questa pagina con la nuova data di
          aggiornamento in evidenza.
        </p>
      </article>

      <footer className="legal-footer">
        <Link to="/terms">Condizioni d&apos;uso</Link>
        <span>·</span>
        <Link to="/auth">Login</Link>
      </footer>
    </section>
  );
}
